import { Button } from 'react-bootstrap';
import SmashPrice from '../../../components/SmashPrice/SmashPrice';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import SmashTable from '../../../components/SmashTable/SmashTable';
import { TableHeaders } from '../../../components/SmashTable/SmashTableHead';
import { useInvoice } from '../hooks/useInvoice';
import { InvoiceDisplay } from '../models/Invoice.interface';


const ListInvoice = () => {
    const [isLoading, invoices] = useInvoice();

    const headers: TableHeaders[] = [{
        label: 'Date',
        accessor: 'created',
        type: 'date',
        sortable: true,
        sortbyOrder: "desc"
    }, {
        label: 'Invoice ID',
        accessor: 'id',
        sortable: false,
    }, {
        label: 'Plan',
        accessor: 'plan',
        sortable: true,
    }, {
        label: 'Price',
        accessor: 'price',
        sortable: false,
    }, {
        label: 'Status',
        accessor: 'status',
        sortable: false,
    },
    {
        label: 'Download',
        accessor: 'download',
        sortable: false,
    }]

    const download = (item: InvoiceDisplay) => {
        const a = document.createElement('a') as HTMLAnchorElement;
        a.href = item.url;
        a.download = `Smash_${item.created}_${item.id}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const renderers: any = {
        download: (item: InvoiceDisplay) => {
            if (item.status === 'Available') {
                return (
                    <>
                        <Button variant="primary" onClick={() => download(item)}>Download</Button>
                    </>
                )
            }
        },
        price: (item: InvoiceDisplay) => {
            return (
                <>
                    <SmashPrice price={item.price} currency={item.currency}></SmashPrice>
                </>
            )

        },
    };

    if (isLoading) {
        return <SmashSpinner />;
    }

    return (
        <SmashTable loading={isLoading} headers={headers} items={invoices} customRenderers={renderers} textFallback={'No invoices'} />
    )

}

export default ListInvoice